var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$options.name},[_c('v-card',[_c('tags-table',{attrs:{"items":_vm.list,"current-page":_vm.pagination.currentPage,"last-page":_vm.pagination.lastPage,"loading":_vm.loading},on:{"onDoReload":_vm.doReload}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }